export default __webpack_public_path__ + "static/media/013-great wall of china.12b954be.svg";